// import $ from "jquery";
import { Collapse } from "bootstrap";
import { init as mModule } from "./magnific-popup.module.js";

export const init = () => {
  // Init panels
  let collapseElementList = document.querySelectorAll(".collapse");
  [...collapseElementList].map(
    (collapseEl) => new Collapse(collapseEl, { toggle: false })
  );

  setTimeout(function () {
    if (document.querySelectorAll(".lightbox").length > 0) mModule();
  }, 500);
};
